import React from "react";
import { LinkButton, Text } from "@networkraildigitalfactory/components";
import styles from "./EvidenceList.module.css";
import { getFileIcon } from "../FileUpload/FileUpload";
import { getBuild } from "../../services/utils";

const EvidenceList = (props) => {
  const { style, evidenceData, title, evidencePath, downloadFile } = props;
  const { env } = getBuild();
  return (
    <div className={styles.evidence_col} style={style}>
      {title && (
        <Text wrapper="h3" type="header" style={{ fontSize: "20px" }}>
          {title}
        </Text>
      )}
      {evidenceData.map((evidence, index) => {
        const { fileType, fileName } = evidence;
        return (
          <div key={index} className={styles.evidence_row}>
            {getFileIcon(fileType)}
            <LinkButton
              type="button"
              name={fileName.split(".")[0]}
              onClick={() => downloadFile(`${env.toLowerCase()}/${evidencePath}${fileName}`)}
              style={{ marginBottom: "3px" }}
            >
              <Text wrapper="span" type="header" className={styles.fileName}>
                {fileName.split(".")[0]}
              </Text>
            </LinkButton>
          </div>
        );
      })}
    </div>
  );
};

export default EvidenceList;
